<template>
  <!-- Themes: 'dropdown, 'dropdown-inline', 'inline' -->
  <div class="w-maxC"
       :style="{opacity: disabled ? .5 : 1}"
       :class="[ {['disabled']: disabled} ,...classList]"
       @mouseover="hoverOn" @mouseleave="hoverOff">

    <!-- Main-component -->
    <slot></slot>

    <!-- Drop-down -->
    <template v-if="isDropdown">
      <svg-item icon="chevronDown" class="size-l main-l mleft-02 mtop-01"/>
    </template>
  </div>
</template>

<script setup>
import {computed, ref} from 'vue'
import stylesJS from "@/assets/styles.js"

const props = defineProps({
  styles: {
    type: String,
    default: ""
  },
  active: {
    type: Boolean,
    default: false
  },
  theme: {
    type: String,
  },
  disabled: {
    type: Boolean,
    default: false
  },
  center: {
    type: Boolean,
  },
  maxWidth: {
    default: false,
    type: Boolean
  }
})

const hover = ref(false)

function hoverOn() {
  if (!props.disabled) {
    hover.value = true
  }
}

function hoverOff() {
  hover.value = false
}

const isDropdown = computed(() => {
  return ['dropdown','dropdown-inline'].includes(props.theme)
})

const isInline = computed(() => {
  return ['inline','dropdown-inline'].includes(props.theme)
})

const classList = computed(() => {
  // Import & defaults
  const importOBJ = stylesJS.get(props.styles)
  let iMain = importOBJ.main || "h"
  iMain = "main-" + iMain
  let iBorder = importOBJ.border || "none"
  iBorder = "border-" + iBorder
  let iBg = importOBJ.bg || "0"
  iBg = "bg-" + iBg
  let iRnd = importOBJ.rnd  || "m"
  iRnd = "rnd-" + iRnd
  let iPad = importOBJ.pad  || "m"
  iPad = "pad-" + iPad
  let mbottom = importOBJ.mbottom  || "00"
  mbottom = "mbottom-" + mbottom
  let mright = importOBJ.mright  || "00"
  mright = "mright-" + mright


  // Theme
  const tInline = isInline.value ? 'inline' : ''
  if (isInline.value) iRnd = 'rnd-s';

  // State
  let sShadow = ''
  if (hover.value) {sShadow = 'shadow'}
  if (props.active) {sShadow = 'bigshadow'}

  let row = 'row-top'
  if(props.center) {
    row = "rowcenter"
  }

  let maxWidth = '';
  if (props.maxWidth) {
    maxWidth = "max-w-9vw"
  }

  return ['component', tInline, row, 'cursor-action', sShadow, iMain, iBg, iPad, iBorder, iRnd, mbottom, mright, maxWidth]
})

</script>

<style scoped>
.inline {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.disabled {
  cursor: default;
}
</style>